window.addEventListener('DOMContentLoaded', function () {
  $(".brand-gallery__item img").click(function (e) {
    e.preventDefault();

    const gray = $("#graydisplay");
    gray.empty(); // 一旦中身を空に

    const img = $("<img>", {
      src: $(this).attr("src"),
      css: {
        maxWidth: "90%",
        maxHeight: "90%",
        boxShadow: "0 0 20px #000",
        cursor: "zoom-out"
      }
    });

    gray.css({
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.85)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    });

    gray.append(img).fadeIn(200);

    gray.off("click").on("click", function () {
      gray.fadeOut(200);
    });
  });
});